exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-43367cc6] .el-steps--horizontal {\n  width: 500px;\n  margin-top: 20px;\n  white-space: nowrap;\n}\n", ""]);

// exports
